import { routerPostCall } from '../../axios';

const signOut = (state, params) => {
  const url = `/auth/logout`;
  return routerPostCall(state, url, params);
};
export default { signOut };
